import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const LegalMentions = () => {
  return (
    <div className="bg-gray-900 pt-14 min-h-screen">
      <Navbar />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-8 text-center">
          Mentions Légales
        </h1>

        <p className="text-gray-400 mb-6">
          Conformément aux dispositions des articles 6-III et 19 de la loi
          n°2004-575 du 21 juin 2004 pour la confiance dans l'économie
          numérique, il est précisé aux utilisateurs du site{" "}
          <strong>WebMinds</strong> l'identité des différents intervenants dans
          le cadre de sa réalisation et de son suivi.
        </p>

        <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-blue-400 pb-2">
          Informations légales
        </h2>
        <p className="text-gray-400 mb-6">
          <strong>Nom de l'entreprise :</strong> WebMinds
          <br />
          <strong>Adresse :</strong> 12 rue sauve Delanoue 77100 Meaux
          <br />
          <strong>Téléphone :</strong> +33 7 72 29 32 55
          <br />
          <strong>Email :</strong> webminds.contact@gmail.com
          <br />
          <strong>Numéro Siren :</strong> 95279981500016
          <br />
          <strong>Capital social :</strong> 0 €<br />
          <strong>Directeur de la publication :</strong> Dayes Owen
        </p>

        <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-green-400 pb-2">
          Hébergement
        </h2>
        <p className="text-gray-400 mb-6">
          <strong>Hébergeur :</strong> Hostinger
          <br />
          <strong>Adresse :</strong> 61 Lordou Vironos Street, 6023 Larnaca, Chypre
          <br />
          <strong>Téléphone :</strong> +33 9 70 80 90 11
          <br />
          <strong>Site Web :</strong>{" "}
          <a
            href="https://www.webminds-agency.com"
            className="text-blue-400 hover:underline"
          >
            www.webminds-agency.com
          </a>
        </p>

        <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-yellow-400 pb-2">
          Propriété intellectuelle
        </h2>
        <p className="text-gray-400 mb-6">
          L'ensemble des éléments présents sur le site <strong>WebMinds</strong>
          , y compris les textes, images, graphiques, logos, et autres contenus,
          sont la propriété exclusive de <strong>WebMinds</strong> ou de ses
          partenaires et sont protégés par les droits de propriété
          intellectuelle en vigueur. Toute reproduction, distribution,
          modification ou exploitation non autorisée de ces éléments est
          interdite sans accord préalable.
        </p>

        <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-red-400 pb-2">
          Responsabilité
        </h2>
        <p className="text-gray-400 mb-6">
          <strong>WebMinds</strong> ne saurait être tenu responsable des erreurs
          ou omissions dans le contenu du site, ni des dommages directs ou
          indirects résultant de l'utilisation du site. Les liens hypertextes
          présents sur le site peuvent diriger vers des sites tiers,{" "}
          <strong>WebMinds</strong> n'exerce aucun contrôle sur ces sites et
          décline toute responsabilité quant à leur contenu.
        </p>

        <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-purple-400 pb-2">
          Données personnelles
        </h2>
        <p className="text-gray-400 mb-6">
          Conformément à la loi "Informatique et Libertés" du 6 janvier 1978
          modifiée en 2004 et au Règlement Général sur la Protection des Données
          (RGPD), vous disposez d'un droit d'accès, de rectification, de
          suppression et d'opposition sur vos données personnelles. Vous pouvez
          exercer ces droits en nous contactant à l'adresse suivante :{" "}
          <strong>webminds.contact@gmail.com</strong>.
        </p>

        {/* <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-blue-400 pb-2">
          Cookies
        </h2>
        <p className="text-gray-400 mb-6">
          Le site <strong>WebMinds</strong> utilise des cookies pour améliorer votre
          expérience utilisateur. Vous pouvez choisir de les accepter ou de les refuser
          via les paramètres de votre navigateur. Pour plus d'informations sur l'utilisation
          des cookies, veuillez consulter notre Politique de Confidentialité.
        </p> */}

        <h2 className="text-3xl font-bold text-white mb-6 border-b-4 border-green-400 pb-2">
          Modification des mentions légales
        </h2>
        <p className="text-gray-400 mb-6">
          <strong>WebMinds</strong> se réserve le droit de modifier à tout
          moment les présentes mentions légales. Les modifications seront
          publiées sur cette page et entreront en vigueur dès leur mise en
          ligne.
        </p>

        <p className="text-gray-400 mb-6">
          Dernière mise à jour : 16 août 2024
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default LegalMentions;
